import fetch from 'isomorphic-fetch';
import Configs from '~/config';
import cloneDeep from 'lodash/cloneDeep';

const baseURL = __CLIENT__ ? '/api' : Configs.apiPath;

const processFetch = (res) => (
  Promise.all([res.ok, res.json()])
    .then(([ok, response]) => {
      if (!ok) {
        return Promise.reject(response);
      }
      const clonedData = cloneDeep(response);
      return Promise.resolve({ data: clonedData });
    })
);

export default {
  get: url => (
    fetch(`${baseURL}${url}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    }).then(processFetch)
  ),
  post: (url, body = {}) => (
    fetch(`${baseURL}${url}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(body),
    }).then(processFetch)
  ),
  delete: (url, body = {}) => (
    fetch(`${baseURL}${url}`, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(body),
    }).then(processFetch)
  ),
  put: (url, body = {}) => (
    fetch(`${baseURL}${url}`, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(body),
    }).then(processFetch)
  ),
};
